// unduhPdf.js — Helper untuk unduh laporan PDF dari endpoint yang butuh token Bearer
// (tidak bisa pakai <a href> biasa karena endpoint-nya diproteksi authMiddleware/adminMiddleware)

export async function unduhPdf(url, token, namaFileFallback = 'laporan.pdf', opsi = {}) {
  const headers = { Authorization: `Bearer ${token}` };
  if (opsi.body) headers['Content-Type'] = 'application/json';
  const res = await fetch(url, { method: opsi.method || 'GET', headers, body: opsi.body ? JSON.stringify(opsi.body) : undefined });
  if (!res.ok) {
    let pesan = 'Gagal mengunduh laporan.';
    try { const data = await res.json(); if (data.error) pesan = data.error; } catch {}
    throw new Error(pesan);
  }
  const blob = await res.blob();
  const namaFile = (() => {
    const cd = res.headers.get('Content-Disposition') || '';
    const match = cd.match(/filename="?([^"]+)"?/);
    return match ? match[1] : namaFileFallback;
  })();
  const objUrl = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = objUrl;
  a.download = namaFile;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(objUrl);
}
